import cn from 'classnames';
import React from 'react';

interface OptionalTagProps {
  isOptional: boolean;
  isFloating: boolean;
}

export const OptionalTag: React.FC<OptionalTagProps> = ({ isOptional, isFloating }) =>
  isOptional ? (
    <span
      className={cn('italic', {
        'text-label-300': isFloating,
        'text-caption-300': !isFloating,
      })}>
      {' (optional)'}
    </span>
  ) : null;
